<div class="showcase-scoreboard-participants-score">
    <span class="showcase-scoreboard-participants">
        <span class="participant-name"> {{ vm.participant1Name }} </span>
        <span class="showcase-scoreboard-live" *ngIf="event.scoreboard && event.scoreboard.started; else preMatch">
            <span class="score">
                <div [msValueSlider]="participant1Score"></div>
            </span>
            {{ isEpcotEnabled ? '@' : '-' }}
            <span class="score">
                <div [msValueSlider]="participant2Score"></div>
            </span>
        </span>
        <ng-template #preMatch>
            <span class="away-indicator-showcase">
                {{ showAwayIndicator ? sitecore.globalMessages.AwayIndicator : isEpcotEnabled ? '@' : '-' }}
            </span>
        </ng-template>
        <span class="participant-name"> {{ vm.participant2Name }} </span>
    </span>
</div>

<div class="showcase-scoreboard-timer">
    <span class="grid-event-info">
        <i class="live-icon" *ngIf="event.scoreboard && event.scoreboard.started">{{ sitecore.event.Live }}</i>
        <ms-event-timer class="grid-event-timer" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard"> </ms-event-timer>
    </span>
</div>
